module.exports = __webpack_public_path__ + "img/icon9.42c3e8da.png";